import { TransformsList } from 'cio/utils/analytics/transforms';
import ObjectModel from 'cio/models/object';

const Transforms: TransformsList = {
  listViewedSearchedOrFiltered(data) {
    return {
      'Filter Operator': data.operator,
      'Number of Object Attribute Conditions': data.object_attributes,
      'Number of Relationship Attribute Conditions': data.relationship_attributes,
      Plan: data.planName,
      'Has Enabled Objects': data.objectsEnabled,
      'Has Objects Data': data.hasObjects,
      'Filtered by Name': data.filteredByName,
      'Name Filter Includes Wildcard': data.nameIncludesWildcard,
    };
  },
  businessTypeSelfSelected(data) {
    return {
      'Business Type': data.businessType,
    };
  },
  base({ model }: { model: ObjectModel }) {
    return {
      cio_object_id: model.attributes.cio_object_id,
      object_id: model.attributes.object_id,
    };
  },
  objectTypeListViewed(data) {
    return {
      Plan: data.planName,
      'Has Enabled Objects': data.hasEnabledObjects,
      'Has Objects Data': data.hasObjectsData,
    };
  },
  relationships(data: {
    source: string;
    peopleCount: number;
    objectCount: number;
    relationshipAttributesCount: number;
  }) {
    return {
      Source: data.source,
      ...(data.peopleCount != null &&
        data.objectCount != null && {
          'Number of People': data.peopleCount,
          'Number of Objects': data.objectCount,
          'Number of Relationship Attributes': data.relationshipAttributesCount,
        }),
    };
  },
};

export default Transforms;
